

class EventDetailViewController extends MUIViewController
{
    static newInstance():EventDetailViewController {
        let vc = new EventDetailViewController("event-detail-view");
        vc.initWithResource("layout/event/EventDetailView.html");
        return vc;
    }

    private ruleTypeComboBox:MUIComboBox = null;
    private segmentedControl:MUISegmentedControl = null;
    private saveButton:MUIButton = null;
    private addPhaseButton:MUIButton = null;
    private addButton:MUIButton = null;
    private optionsButton:MUIButton = null;

    private pageController:MUIPageController = null;
    
    // Tabs, in the order of the segmented control (EventDetailView.html)
    private static readonly TAB_INFO     = 0;
    private static readonly TAB_PLANNING = 1;
    private static readonly TAB_QUOTES   = 2;
    private static readonly TAB_WEB      = 3;
    private static readonly TAB_TICKETS  = 4;
    private static readonly TAB_ZONES    = 5;
    private static readonly TAB_MAP      = 6;
    private static readonly TAB_CODES    = 7;
    private static readonly TAB_ACTIONS  = 8;

    private infoVC:EventDetailInfoViewController = null;
    private planningVC:EventDetailPlanningViewController = null;
    private budgetVC:EventDetailBudgetViewController = null;
    private webVC:EventDetailWebViewController = null;
    private ticketsVC:EventDetailTicketsViewController = null;
    private zoneSetupViewController:EventProgramDetailZoneSetupViewController = null;
    private tablemapVC:EventDetailMapViewController = null;
    private codesVC:OfferCodeDetailViewController = null;
    private actionVC:EventDetailActionViewController = null;

    private cf = MUIWebApplication.sharedInstance().delegate.currencyFormatter;
    private df = MUIWebApplication.sharedInstance().delegate.dateFormatter;

    viewDidLoad(){
        super.viewDidLoad();

        this.ruleTypeComboBox = MUIOutlet(this, "rule-type-cb", "MUIComboBox");
        this.ruleTypeComboBox.hidden = true;
        this.ruleTypeComboBox.setOnChangeAction(this, this.setRuleTypeAction);
        
        this.segmentedControl = MUIOutlet(this, 'segmented_control', 'MUISegmentedControl');
        this.segmentedControl.setAction(this, function (this:EventDetailViewController, control, index) { 
            this.ruleTypeComboBox.hidden = index != EventDetailViewController.TAB_ZONES;
            // "+" adds a phase in Planning and a rule in Zones
            this.addButton.hidden = !(index == EventDetailViewController.TAB_PLANNING || index == EventDetailViewController.TAB_ZONES);
            this.pageController.showPageAtIndex(index);
        });

        this.saveButton = MUIOutlet(this, 'save-btn','MUIButton');
        this.saveButton.setAction(this, function(){
           DBHelper.saveMainContext();
        });

        this.addButton = MUIOutlet(this, "add-btn", "MUIButton");
        this.addButton.hidden = true;
        this.addButton.setAction(this, this.addButtonAction);

        this.optionsButton = MUIOutlet(this, "options-btn", "MUIButton");
        this.optionsButton.setAction(this, this.showOptions);

        this.pageController = MUIOutlet(this, 'pdpage_controller', 'MUIPageController');

        this.infoVC = new EventDetailInfoViewController("event-detail-info-view");
        this.infoVC.initWithResource("layout/event/EventDetailInfoView.html");
        this.infoVC.navigationController = this.navigationController;
        this.pageController.addPageViewController(this.infoVC);

        this.planningVC = new EventDetailPlanningViewController("event-detail-planning-view");
        this.planningVC.initWithResource("layout/event/EventDetailPlanningView.html");
        this.planningVC.navigationController = this.navigationController;
        this.pageController.addPageViewController(this.planningVC);
       
        this.budgetVC = new EventDetailBudgetViewController("event-detail-budget-view");
        this.budgetVC.initWithResource("layout/event/EventDetailBudgetView.html");
        this.pageController.addPageViewController(this.budgetVC);

        this.webVC = new EventDetailWebViewController("event-detail-web-view");
        this.webVC.initWithResource("layout/event/EventDetailWebView.html");
        this.pageController.addPageViewController(this.webVC);

        this.ticketsVC = new EventDetailTicketsViewController("event-detail-tickets-view");
        this.ticketsVC.initWithResource("layout/event/EventDetailTicketsView.html");
        this.pageController.addPageViewController(this.ticketsVC);

        this.zoneSetupViewController = new EventProgramDetailZoneSetupViewController("parties-booking-zone-setup");
        this.zoneSetupViewController.initWithResource("layout/event_programs/EventProgramsBookingZoneSetupView.html");
        this.pageController.addPageViewController(this.zoneSetupViewController);

        this.tablemapVC = new EventDetailMapViewController("event-detail-map-view");
        this.tablemapVC.initWithResource("layout/event/EventDetailMapView.html");
        this.pageController.addPageViewController(this.tablemapVC);

        this.codesVC = new OfferCodeDetailViewController("offer-code-detail-view");
        this.codesVC.initWithResource("layout/offers/OfferCodeDetailView.html");
        this.pageController.addPageViewController(this.codesVC);

        this.actionVC = new EventDetailActionViewController("event-detail-action-view");
        this.actionVC.initWithResource("layout/event/EventDetailActionView.html");
        this.pageController.addPageViewController(this.actionVC);
    }

    viewWillAppear(animate?){
        super.viewWillAppear(animate);
        this.updateUI(); 
    }

    private _event:VenueEvent = null;
    set event(value:VenueEvent){
        this._event = value;
        this.updateUI();
    }

    private updateUI(){
        if(this.viewIsLoaded == false || this._event == null) return;

        this.infoVC.event = this._event;
        this.planningVC.event = this._event;
        this.webVC.event = this._event;
        this.ticketsVC.event = this._event;
        this.zoneSetupViewController.event = this._event as any;
     } 

     private setRuleTypeAction(control, index){
         this.zoneSetupViewController.ruleType = parseInt(index);
     }

    private showOptions(){
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("OPTIONS","OPTIONS"), MIOLocalizeString("CHOOSE_AN_ACTION","CHOOSE AN ACTION"), MUIAlertViewStyle.Default);

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CHANGE_NAME", "CHANGE NAME"), MUIAlertActionStyle.Default, this, function(this:EventDetailViewController){
            this.showChangeNameAlert();
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("DELETE", "DELETE"), MUIAlertActionStyle.Destructive, this, function(this:EventDetailViewController){
            DBHelper.deleteObjectFromMainContext(this._event, true);
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController(avc, true);
    }

    private showChangeNameAlert(){
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("CHANGE_NAME","CHANGE NAME"), MIOLocalizeString("TYPE_THE_NEW_NAME","TYPE THE NEW NAME"), MUIAlertViewStyle.Default);

        avc.addTextFieldWithConfigurationHandler(this, function(this:EventDetailViewController, textField:MUITextField){
            textField.setPlaceholderText(MIOLocalizeString("NAME","NAME"));
            textField.text = this._event?.name;
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("OK","OK"), MUIAlertActionStyle.Default, this, function(this:EventDetailViewController){
            let name = avc.textFields[0].text?.trim() ?? "";
            if (name.length == 0) {
                AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("MUST_HAVE_A_NAME", "MUST HAVE A NAME"));
                return;
            }

            this._event.name = name;
            DBHelper.saveMainContext();
            this.updateUI();
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController(avc, true);
    }

     private addButtonAction(){
        switch(this.segmentedControl.selectedSegmentedIndex) {
            case EventDetailViewController.TAB_PLANNING: this.planningVC.addPhase(); break;
            case EventDetailViewController.TAB_ZONES:    this.zoneSetupViewController.addRule(); break;
        }
     }

}